import { featureEnabled, isCustomerAdmin, projectFeatureEnabled, userFeatureEnabled } from "./helpers";

export interface RosterMayInterface {
  // roster/attendance-types
  (session: SessionInterface, path: "roster/attendance-types"): boolean;
  (session: SessionInterface, path: "roster/attendance-types", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "roster/attendance-types",
    action: "edit" | "delete",
    attendanceType: RosterAttendanceTypeRef,
  ): boolean;

  // roster/tasks
  (session: SessionInterface, path: "roster/tasks"): boolean;
  (session: SessionInterface, path: "roster/tasks", action: "new"): boolean;
  (session: SessionInterface, path: "roster/tasks", action: "edit" | "delete", task: RosterTaskRef): boolean;

  // roster/groups
  (session: SessionInterface, path: "roster/groups"): boolean;
  (session: SessionInterface, path: "roster/groups", action: "new"): boolean;
  (session: SessionInterface, path: "roster/groups", action: "edit" | "delete", group: RosterGroupRef): boolean;

  // roster/standard-attendances
  (session: SessionInterface, path: "roster/standard-attendances"): boolean;
  (session: SessionInterface, path: "roster/standard-attendances", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "roster/standard-attendances",
    action: "edit" | "delete",
    wt: RosterStandardAttendanceRef,
  ): boolean;

  // roster/standard-days
  (session: SessionInterface, path: "roster/standard-days"): boolean;
  (session: SessionInterface, path: "roster/standard-days", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "roster/standard-days",
    action: "edit" | "delete",
    wt: RosterStandardDayRef,
  ): boolean;

  // roster/day-planning
  (session: SessionInterface, path: "roster/attendance-planning"): boolean;
  (session: SessionInterface, path: "roster/day-planning"): boolean;

  (session: SessionInterface, path: "roster"): boolean;
  (session: SessionInterface, path: "roster", action: "day"): boolean;
  (session: SessionInterface, path: "roster", action: "month"): boolean;
  (session: SessionInterface, path: "roster", action: "notifications"): boolean;
}

const ATTENDANCE_TYPE_PERMISSIONS: PermissionType<RosterAttendanceTypeRef> = {
  "roster/attendance-types": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const TASKS_PERMISSIONS: PermissionType<RosterTaskRef> = {
  "roster/tasks": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const GROUPS_PERMISSIONS: PermissionType<RosterGroupRef> = {
  "roster/groups": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const STANDARD_ATTENDANCES_PERMISSIONS: PermissionType<RosterStandardAttendanceRef> = {
  "roster/standard-attendances": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const STANDARD_DAYS_PERMISSIONS: PermissionType<RosterStandardDayRef> = {
  "roster/standard-days": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const ATTENDANCE_PLANNING_PERMISSIONS: PermissionType<RosterAttendanceRef> = {
  "roster/attendance-planning": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const DAY_PLANNING_PERMISSIONS: PermissionType<RosterHourRef> = {
  "roster/day-planning": {
    index: ({ currentUser, currentCustomer }) =>
      projectFeatureEnabled(currentCustomer, "roster") && userFeatureEnabled(currentUser, "roster_admin"),
  },
};

const ROSTER_PERMISSIONS: PermissionType<null> = {
  roster: {
    index: ({ currentUser, currentCustomer }) => featureEnabled(currentUser, currentCustomer, "roster"),
    notifications: ({ currentUser, currentCustomer }, _resource) =>
      featureEnabled(currentUser, currentCustomer, "roster") &&
      (isCustomerAdmin(currentUser, currentCustomer) || userFeatureEnabled(currentUser, "roster_admin")),
  },
};

const RosterPermissions = {
  ...ATTENDANCE_TYPE_PERMISSIONS,
  ...TASKS_PERMISSIONS,
  ...GROUPS_PERMISSIONS,
  ...STANDARD_ATTENDANCES_PERMISSIONS,
  ...STANDARD_DAYS_PERMISSIONS,
  ...ATTENDANCE_PLANNING_PERMISSIONS,
  ...DAY_PLANNING_PERMISSIONS,
  ...ROSTER_PERMISSIONS,
};

export default RosterPermissions;
